export default __webpack_public_path__ + "locales/sq-AL/SharingPanel.json?hash=73ccb68cdc535f459c725936ef4be1f7";